import { isUndefinedOrNull } from '../../TypeHelpers';
import where from './where';
export default function last(iterable, predicate) {
    if (!isUndefinedOrNull(predicate)) {
        iterable = where(iterable, predicate);
    }
    let current;
    for (const item of iterable) {
        current = item;
    }
    if (isUndefinedOrNull(current)) {
        throw new Error("There is no last item matching the predicate!");
    }
    return current;
}
